import { createTantoSvagoSlice, TantoSvagoState } from '@/store/createTantoSvagoSlice';
import { create } from 'zustand';
import { devtools, persist, createJSONStorage } from 'zustand/middleware';
import { createBookingInformationsSlice, BookingInformationsState } from './createBookingInformationsSlice';
import { createCheckoutSlice, CheckoutState } from './createCheckoutSlice';
import { CommonState, createCommonSlice } from '@/store/createCommonSlice';
import { PatientState, createPatientSlice } from './createPatientSlice';
import { RESERVATION_OTP_STATE_KEYS, ReservationOtpState, createReservationOtpSlice } from './createReservationOtpSlice';

const NOT_PERSISTED_KEYS: string[] = ['isBookingInformationsLoading', 'channel', ...RESERVATION_OTP_STATE_KEYS];

export const useInclinicStore = create<BookingInformationsState & CheckoutState & CommonState & PatientState & ReservationOtpState>()(
  devtools(
    persist(
      (...args) => ({
        ...createBookingInformationsSlice(...args),
        ...createCheckoutSlice(...args),
        ...createCommonSlice(...args),
        ...createPatientSlice(...args),
        ...createReservationOtpSlice(...args),
      }),
      {
        name: 'inclinic-store',
        partialize: state => Object.fromEntries(Object.entries(state).filter(([key]) => !NOT_PERSISTED_KEYS.includes(key))),
        merge: (persistedState, currentState) => ({
          ...currentState,
          ...(persistedState as object),
          channel: currentState.channel,
        }),
      },
    ),
  ),
);

export const useTantoSvagoStore = create<TantoSvagoState>()(
  devtools(
    persist(
      (...args) => ({
        ...createTantoSvagoSlice(...args),
      }),
      {
        name: 'tantosvago-store',
        storage: createJSONStorage(() => sessionStorage),
      },
    ),
  ),
);
